import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Grid, Typography, Button } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import axios from "axios";
import Logo from "../../commonComponents/Logo/Logo";
import {
  videPageContainer,
  videoPageBar,
  videoFrame,
  videoPlayer,
  videoCards,
  videoContentArea,
  dividerStyle,
  videoDescription,
  videoButton,
} from "./videoPageStyling";
import { url } from "../../Constant";
import DashBoard from "../../components/DashBoard/DashBoard";

const VideoPage = () => {
  const [showVideo, setShowVideo] = useState({});
  const [videos, setVideos] = useState([]);
  const [like, setLike] = useState(0);
  const [dislike, setDisLike] = useState(0);
  const params = useParams();
  const history = useHistory();

  const fetchVideos = async () => {
    try {
      let videoUrl = await axios.get(`${url}/v1/videos/${params.id}`);
      console.log(videoUrl.data.videoLink);
      setShowVideo({ ...videoUrl.data });
    } catch (error) {
      return null;
    }
  };
  const fetchVideoList = async () => {
    try {
      let videoList = await axios.get(`${url}/v1/videos`);
      console.log(videoList);
      setVideos([...videoList.data.videos]);
    } catch (error) {
      return null;
    }
  };

  const updateVotes = async () => {
    try {
       const response = await axios.patch(
        `${url}/v1/videos/${params.id}/votes`,
        {
          vote: "downVote",
          change: "increase",
        },
        {
          headers: { "Content-type": "application/json; charset=UTF-8" },
        }
      );
      return response;
    }
    catch (error) {
      return null;
    }
  }
  
  useEffect(() => {
    fetchVideos();
    fetchVideoList();
  }, [params]);
  // console.log(showVideo.videoLink);

  const calculateDays = (date1) => {
    const d1 = new Date(date1);
    const d2 = new Date();
    const diffDates = parseInt((d2 - d1) / (1000 * 60 * 60 * 24 * 30 * 12), 10);
    if (diffDates > 0) {
      return diffDates + " years ago";
    } else {
      return (
        parseInt((d2 - d1) / (1000 * 60 * 60 * 24 * 30 * 12), 10) +
        " months ago"
      );
    }
  };

  return (
    <>
      <div style={videoPageBar} onClick={() => history.push("/")}>
        <Logo />
      </div>
      <div style={videPageContainer}>
        <div style={videoFrame}>
          <iframe
            src={`https://www.${showVideo.videoLink}`}
            title={showVideo.title}
            style={videoPlayer}
            className="video-tile"
          />

          {/* <Divider variant="middle" /> */}
        </div>
        <div style={videoContentArea}>
          <div style={videoDescription}>
            <Typography>{showVideo.title}</Typography>
            <Typography>
              <span style={{ paddingRight: "10px" }}>
                {showVideo.contentRating}
              </span>
              <span>{calculateDays(showVideo.releaseDate)}</span>
            </Typography>
          </div>
          <div style={videoButton}>
            <Button
              startIcon={<ThumbUpIcon />}
              onClick={() =>( setLike(like + 1),updateVotes())}
            >
              {like}
            </Button>
            <Button
              startIcon={<ThumbDownIcon />}
              onClick={() => (setDisLike(dislike + 1),updateVotes())}
            >
              {dislike}
            </Button>
          </div>
        </div>

        <hr style={dividerStyle} />
        <div>
          <Grid
            container
            spacing={2}
            item
            justifyContent="center"
            alignItems="center"
            style={videoCards}
          >
            {videos.map((videoEle) => (
              <Grid item key={videoEle._id}>
                <DashBoard
                  id={videoEle._id}
                  image={videoEle.previewImage}
                  title={videoEle.title}
                  releaseDate={videoEle.releaseDate}
                  videoLink={videoEle.videoLink}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </>
  );
};

export default VideoPage;
